@if (isActive()) {
  <div
    class="mdw-slide"
    [class.no-animation]="!shouldAnimate()"
    [class.dir-forward]="direction() === 'forward'"
    [class.dir-backward]="direction() === 'backward'"
    [style.--mdw-slide-dur]="animationDuration() + 's'"
    [style.--mdw-slide-ease]="animationEasing()"
    [animate.enter]="enterClass()"
    [animate.leave]="leaveClass()"
  >
    <ng-content></ng-content>
  </div>
}
